// src/layout/MainLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import { useTheme } from "../context/ThemeContext";

const MainLayout = () => {
  const { theme } = useTheme();

  return (
    <div className="flex min-h-screen">

      {/* Sidebar */}
      <Sidebar />

      <div className="flex-1 flex flex-col">
        <Navbar />
        <main className={`flex-1 p-4 bg-gradient-to-r ${theme}`}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
